import { PropertyConfig, PropertyOptionsDuration } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { keyof } from "@cervval.js/common/src/tools/object.tools";
import { BookingSession } from "../data/booking.dto";
import { I18nPropertyConfig } from "./propertyConfig.i18n";

/** Product override PC for booking session */
export function getProductOverridePropertyConfig(): PropertyConfig<PropertyConfigType, PropertyOptionsDuration>[] {
    const i18n = I18nPropertyConfig().productOverride;
    return [
        {
            label: i18n.price,
            propertyName: keyof<BookingSession>("price"),
            typeUid: PropertyConfigType.NUMBER,
            options: {
                suffix: "€"
            },
            validators: {
                required: true
            }
        },
        {
            label: i18n.duration,
            propertyName: keyof<BookingSession>("duration"),
            typeUid: PropertyConfigType.DURATION,
            options: {
                pickerOptions: {
                    useSeconds: true,
                    enableDurationSelectors: true
                }
            },
            validators: {
                required: true
            }
        },
        {
            label: i18n.description,
            propertyName: keyof<BookingSession>("description"),
            typeUid: PropertyConfigType.TEXTAREA
        }
    ];
}